// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DeviceSvg from '@rsuite/icon-font/lib/device/Device';
var Device = createSvgIcon({
  as: DeviceSvg,
  ariaLabel: 'device',
  category: 'device',
  displayName: 'Device'
});
export default Device;